import React, { useCallback, useRef } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { Icons } from "./icons";
import { Config } from "../utils/config";
import { t } from "i18next";

const mapContainerStyle = {
  height: "100%",
  width: "100%",
  borderRadius: "8px",
};

export default function GoogleMapViewOnly({ lat, lng }) {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: Config.env.app.google_map_key as string,
    libraries: ["places"],
  });

  const mapRef = useRef();
  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  if (loadError) return "Error";

  return (
    <div className="h-[320px] flex justify-center items-center shadow-lg shadow-green/50 rounded-lg overflow-hidden">
      {!isLoaded ? (
        <div className="flex flex-col items-center justify-center">
          <Icons.spinner className="size-5 animate-spin" />
          <h2>{t("please_wait")}</h2>
        </div>
      ) : (
        <GoogleMap
          key={lat}
          mapContainerStyle={mapContainerStyle}
          zoom={17}
          center={{
            lat: lat,
            lng: lng,
          }}
          options={{
            disableDefaultUI: true,
            zoomControl: true,
          }}
          onLoad={onMapLoad}
        >
          <Marker position={{ lat: lat, lng: lng }} draggable={false} />
        </GoogleMap>
      )}
    </div>
  );
}
